import { assert, Test } from "oc-e2e-testrunner";
import { assertEqualsBestellliste, resetArrangement } from "./utils";

export default {
  name: "TestAuswahlaccessoren",
};

const isVoreinstellungMitEAntrieb =
  APP.richMetadata.findAuswahlwert("E_Antrieb_mit")?.Voreinstellung;

export const testAuswahlenFürFüllungsseiteUndGehflügelseiteSystem: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 15;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  [
    {
      form: "Doppeltor",
      füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
    },
    {
      form: "Rechteck",
      füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
    },
    {
      form: "Einzeltor",
      füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
    },
    {
      form: "Rechteck",
      füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
    },
    {
      form: "Doppeltor",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
    {
      form: "Rechteck",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
    {
      form: "Einzeltor",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
  ].forEach((json) => {
    const element = agt.createElementFromJson(json);
    s.addPart(element);
  });
  agt.update3d();
  const actual = s.getElemente().map((e) => {
    const { form, füllungAuswahlwert } = e.toJSON();
    APP.arrangement.setSelectedObjects([e]);
    agt.update3d();
    const keys = (auswahlKey) =>
      agt.auswahlAccessoren[auswahlKey].möglicheAuswahlwerte.map((w) => w.Key);
    return {
      form,
      füllungAuswahlwert,
      Gehflügel: keys("Gehflügel"),
      Füllungsseite: keys("Füllungsseite"),
    };
  });
  assert.deepEquals(
    [
      {
        form: "Doppeltor",
        füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
        Gehflügel: ["Gehflügel_links", "Gehflügel_rechts"],
        Füllungsseite: ["Füllungsseite_A"],
      },
      {
        form: "Rechteck",
        füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A"],
      },
      {
        form: "Einzeltor",
        füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A"],
      },
      {
        form: "Rechteck",
        füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A"],
      },
      {
        form: "Doppeltor",
        füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
        Gehflügel: ["Gehflügel_links", "Gehflügel_rechts"],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
      {
        form: "Rechteck",
        füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
      {
        form: "Einzeltor",
        füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
    ],
    actual
  );
};

export const testAuswahlenFürFüllungsseiteUndGehflügelseiteSquadra: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 15;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.inspiration = APP.richMetadata.findAuswahlwert(
    "Inspiration SQUADRA Vorgarten Silber"
  )?.Inspiration[0];
  agt.update3d();
  const s = agt.segmente[0];
  [
    {
      form: "Rechteck",
      füllungAuswahlwert: "SQUADRA Silber",
      detailSerie: "SQUADRA Vorgarten",
    },
    {
      form: "Doppeltor",
      füllungAuswahlwert: "SQUADRA Silber",
      detailSerie: "SQUADRA Vorgarten",
    },
    {
      form: "Rechteck",
      füllungAuswahlwert: "SQUADRA Silber",
      detailSerie: "SQUADRA Vorgarten",
    },
    {
      form: "Einzeltor",
      füllungAuswahlwert: "SQUADRA Silber",
      detailSerie: "SQUADRA Vorgarten",
    },
    {
      form: "Doppeltor",
      füllungAuswahlwert: "SQUADRA Silber",
      detailSerie: "SQUADRA Vorgarten",
      breite: 3.11,
      höhe: 0.9,
    },
  ].forEach((json) => {
    const element = agt.createElementFromJson(json);
    s.addPart(element);
    agt.update3d();
  });
  const actual = s.getElemente().map((e) => {
    const { form, füllungAuswahlwert } = e.toJSON();
    APP.arrangement.setSelectedObjects([e]);
    agt.update3d();
    const keys = (auswahlKey) =>
      agt.auswahlAccessoren[auswahlKey].möglicheAuswahlwerte.map((w) => w.Key);
    return {
      form,
      füllungAuswahlwert,
      Gehflügel: keys("Gehflügel"),
      Füllungsseite: keys("Füllungsseite"),
    };
  });
  assert.deepEquals(
    [
      {
        form: "Doppeltor",
        füllungAuswahlwert: "SQUADRA Silber",
        Gehflügel: ["Gehflügel_links", "Gehflügel_rechts"],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
      {
        form: "Einzeltor",
        füllungAuswahlwert: "SQUADRA Silber",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
      {
        form: "Rechteck",
        füllungAuswahlwert: "SQUADRA Silber",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
      {
        form: "Doppeltor",
        füllungAuswahlwert: "SQUADRA Silber",
        Gehflügel: ["Gehflügel_links", "Gehflügel_rechts"],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
      {
        form: "Rechteck",
        füllungAuswahlwert: "SQUADRA Silber",
        Gehflügel: [],
        Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
      },
    ],
    actual
  );
};

export const testSquadraVorgartenDoppeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 4;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.inspiration = APP.richMetadata.findAuswahlwert(
    "Inspiration SQUADRA Vorgarten Silber"
  )?.Inspiration[0];
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    form: "Doppeltor",
    füllungAuswahlwert: "SQUADRA Silber",
    detailSerie: "SQUADRA Vorgarten",
    breite: 3.11,
    höhe: 0.9,
  });
  s.addPart(element);
  agt.update3d();
  APP.arrangement.setSelectedObjects(element);
  const möglicheAuswahlwerte = () => {
    agt.update3d();
    const keys = (auswahlKey) =>
      agt.auswahlAccessoren[auswahlKey].möglicheAuswahlwerte.map((w) => w.Key);
    return {
      Gehflügel: keys("Gehflügel"),
      Füllungsseite: keys("Füllungsseite"),
    };
  };
  isVoreinstellungMitEAntrieb
    ? assertEqualsBestellliste(
        [
          {
            ArtikelID: "4599",
            Anzahl: 1,
          },
          {
            ArtikelID: "732",
            Anzahl: 1,
          },
        ],
        agt.bestellliste
      )
    : assertEqualsBestellliste(
        [
          {
            ArtikelID: "4595",
            Anzahl: 1,
          },
          {
            ArtikelID: "732",
            Anzahl: 1,
          },
          {
            ArtikelID: "1251",
            Anzahl: 1,
          },
          {
            ArtikelID: "2551",
            Anzahl: 1,
          },
        ],
        agt.bestellliste
      );
  assert.deepEquals(
    {
      Gehflügel: ["Gehflügel_links", "Gehflügel_rechts"],
      Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
    },
    möglicheAuswahlwerte()
  );
  element.gehflügelAuswahlwert = APP.richMetadata.findAuswahlwert("Gehflügel_rechts");
  agt.update3d();
  isVoreinstellungMitEAntrieb
    ? assertEqualsBestellliste(
        [
          {
            ArtikelID: "4599",
            Anzahl: 1,
          },
          {
            ArtikelID: "732",
            Anzahl: 1,
          },
        ],
        agt.bestellliste
      )
    : assertEqualsBestellliste(
        [
          {
            ArtikelID: "4595",
            Anzahl: 1,
          },
          {
            ArtikelID: "732",
            Anzahl: 1,
          },
          {
            ArtikelID: "1251",
            Anzahl: 1,
          },
          {
            ArtikelID: "2551",
            Anzahl: 1,
          },
        ],
        agt.bestellliste
      );
  assert.deepEquals(
    {
      Gehflügel: ["Gehflügel_links", "Gehflügel_rechts"],
      Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
    },
    möglicheAuswahlwerte()
  );
  element.gehflügelAuswahlwert = APP.richMetadata.findAuswahlwert("Gehflügel_links");
  element.füllungsseiteAuswahlwert = APP.richMetadata.findAuswahlwert("Füllungsseite_A");
  agt.update3d();
  isVoreinstellungMitEAntrieb
    ? assertEqualsBestellliste(
        [
          {
            ArtikelID: "4599",
            Anzahl: 1,
          },
          {
            ArtikelID: "732",
            Anzahl: 1,
          },
        ],
        agt.bestellliste
      )
    : assertEqualsBestellliste(
        [
          {
            ArtikelID: "2562",
            Anzahl: 1,
          },
          {
            ArtikelID: "732",
            Anzahl: 1,
          },
          {
            ArtikelID: "1251",
            Anzahl: 1,
          },
          {
            ArtikelID: "2551",
            Anzahl: 1,
          },
        ],
        agt.bestellliste
      );
  assert.deepEquals(
    {
      Gehflügel: ["Gehflügel_links", "Gehflügel_rechts"],
      Füllungsseite: ["Füllungsseite_A", "Füllungsseite_B"],
    },
    möglicheAuswahlwerte()
  );
};
